import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar traducciones compartidas
import commonES from '@/shared/locales/es/common.json';
import commonEN from '@/shared/locales/en/common.json';
import commonHT from '@/shared/locales/ht/common.json';
import commonFR from '@/shared/locales/fr/common.json';

// Importar traducciones del componente actualizarPerfil
import actualizarPerfilES from '@/shared/components/ActualizarPerfilModal/locales/es/actualizarPerfil.json';
import actualizarPerfilEN from '@/shared/components/ActualizarPerfilModal/locales/en/actualizarPerfil.json';
import actualizarPerfilHT from '@/shared/components/ActualizarPerfilModal/locales/ht/actualizarPerfil.json';
import actualizarPerfilFR from '@/shared/components/ActualizarPerfilModal/locales/fr/actualizarPerfil.json';

// Importar traducciones del módulo calendar
import calendarES from '@/modules/calendar/locales/es/calendar.json';
import calendarEN from '@/modules/calendar/locales/en/calendar.json';
import calendarHT from '@/modules/calendar/locales/ht/calendar.json';
import calendarFR from '@/modules/calendar/locales/fr/calendar.json';

// Importar traducciones del módulo archivo
import archivoES from '@/modules/Archivo/locales/es/archivo.json';
import archivoEN from '@/modules/Archivo/locales/en/archivo.json';
import archivoHT from '@/modules/Archivo/locales/ht/archivo.json';
import archivoFR from '@/modules/Archivo/locales/fr/archivo.json';

// Importar traducciones de DocumentosPersonales
import documentosPersonalesES from '@/shared/components/ConfiguracionPerfil/DocumentosPersonales/locales/es/documentosPersonales.json';
import documentosPersonalesEN from '@/shared/components/ConfiguracionPerfil/DocumentosPersonales/locales/en/documentosPersonales.json';
import documentosPersonalesHT from '@/shared/components/ConfiguracionPerfil/DocumentosPersonales/locales/ht/documentosPersonales.json';
import documentosPersonalesFR from '@/shared/components/ConfiguracionPerfil/DocumentosPersonales/locales/fr/documentosPersonales.json';

// Configuración de i18next
i18n
  // Detectar idioma del navegador/localStorage
  .use(LanguageDetector)
  // Habilitar react-i18next
  .use(initReactI18next)
  // Inicializar
  .init({
    // Recursos de traducción
    resources: {
      es: {
        common: commonES,
        calendar: calendarES,
        archivo: archivoES,
        actualizarPerfil: actualizarPerfilES,
        documentosPersonales: documentosPersonalesES,
      },
      en: {
        common: commonEN,
        calendar: calendarEN,
        archivo: archivoEN,
        actualizarPerfil: actualizarPerfilEN,
        documentosPersonales: documentosPersonalesEN,
      },
      ht: {
        common: commonHT,
        calendar: calendarHT,
        archivo: archivoHT,
        actualizarPerfil: actualizarPerfilHT,
        documentosPersonales: documentosPersonalesHT,
      },
      fr: {
        common: commonFR,
        calendar: calendarFR,
        archivo: archivoFR,
        actualizarPerfil: actualizarPerfilFR,
        documentosPersonales: documentosPersonalesFR,
      },
    },

    // Idioma por defecto
    fallbackLng: 'es',

    // Idiomas soportados
    supportedLngs: ['es', 'en', 'ht', 'fr'],

    // Namespace por defecto
    defaultNS: 'common',

    // Configuración de detección
    detection: {
      // Orden de detección: localStorage -> navegador
      order: ['localStorage', 'navigator'],
      // Cache del idioma seleccionado
      caches: ['localStorage'],
      // Key para localStorage
      lookupLocalStorage: 'i18nextLng',
    },

    // Interpolación
    interpolation: {
      escapeValue: false, // React ya escapa por defecto
    },

    // Debug en desarrollo
    debug: import.meta.env.DEV,

    // React specific
    react: {
      useSuspense: false,
    },
  });

export default i18n;
